import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=d0fbeb26&scoped=true"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=d0fbeb26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fbeb26",
  null
  
)

export default component.exports